<div class="d-flex flex-column vh-100">
    <app-header />
    <main class="route-shell flex-grow-1 overflow-auto">
        <router-outlet />
    </main>
    <redirect-notice />
</div>
